// extracted by mini-css-extract-plugin
export default {"modal":"payment-card-delete_modal__50aae","isProcessing":"payment-card-delete_isProcessing__bac5a","logo":"payment-card-delete_logo__989f6"};